var map = {
	"./phone-en/EN_1.webp": 364,
	"./phone-en/EN_2.webp": 4916,
	"./phone-en/EN_3.webp": 2018,
	"./phone-en/EN_4.webp": 3057,
	"./phone-en/EN_5.webp": 1351,
	"./phone-en/EN_6.webp": 869,
	"./phone-en/EN_7.webp": 188,
	"./phone-en/EN_8.webp": 2080,
	"./phone-in/IN_1.webp": 5030,
	"./phone-in/IN_2.webp": 3381,
	"./phone-in/IN_3.webp": 1900,
	"./phone-in/IN_4.webp": 7179,
	"./phone-in/IN_5.webp": 8941,
	"./phone-in/IN_6.webp": 101,
	"./phone-in/IN_7.webp": 2989,
	"./phone-in/IN_8.webp": 4847,
	"./phone-ms/MAS_1.webp": 3364,
	"./phone-ms/MAS_2.webp": 8090,
	"./phone-ms/MAS_3.webp": 9841,
	"./phone-ms/MAS_4.webp": 9331,
	"./phone-ms/MAS_5.webp": 8557,
	"./phone-ms/MAS_6.webp": 238,
	"./phone-ms/MAS_7.webp": 4707,
	"./phone-ms/MAS_8.webp": 1503,
	"./phone-tw/ZH_1.webp": 2470,
	"./phone-tw/ZH_2.webp": 744,
	"./phone-tw/ZH_3.webp": 870,
	"./phone-tw/ZH_4.webp": 2612,
	"./phone-tw/ZH_5.webp": 3285,
	"./phone-tw/ZH_6.webp": 6331,
	"./phone-tw/ZH_7.webp": 7347,
	"./phone-tw/ZH_8.webp": 3326,
	"./phone-vn/VN_1.webp": 1635,
	"./phone-vn/VN_2.webp": 6075,
	"./phone-vn/VN_3.webp": 8177,
	"./phone-vn/VN_4.webp": 9402,
	"./phone-vn/VN_5.webp": 3288,
	"./phone-vn/VN_6.webp": 2249,
	"./phone-vn/VN_7.webp": 9387,
	"./phone-vn/VN_8.webp": 9634,
	"./phone-zh/ZH_1.webp": 2288,
	"./phone-zh/ZH_2.webp": 7183,
	"./phone-zh/ZH_3.webp": 6359,
	"./phone-zh/ZH_4.webp": 6768,
	"./phone-zh/ZH_5.webp": 8369,
	"./phone-zh/ZH_6.webp": 6090,
	"./phone-zh/ZH_7.webp": 4561,
	"./phone-zh/ZH_8.webp": 3835
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5121;